// 全局替换函数，处理多重转义的数学符号
window.replaceMathJaxSymbols = function() {
  // 处理文档中的所有文本节点
  function walkTextNodes(node) {
    if (node.nodeType === 3) {
      // 处理\boldsymbol符号，确保正确渲染加粗向量
      node.nodeValue = node.nodeValue.replace(/\\\\\\\\boldsymbol/g, '\\\\boldsymbol')
      // 处理点积符号
      node.nodeValue = node.nodeValue.replace(/\\\\cdot/g, '\\cdot')
    } else if (node.nodeType === 1 && !['script', 'style', 'textarea', 'noscript'].includes(node.tagName.toLowerCase())) {
      Array.from(node.childNodes).forEach(walkTextNodes)
    }
  }

  // 处理整个文档
  Array.from(document.body.childNodes).forEach(walkTextNodes)
}

// MathJax配置
/* global MathJax */
window.MathJax = {
  tex: {
    inlineMath: [['$', '$'], ['\\(', '\\)']],
    displayMath: [['$$', '$$'], ['\\[', '\\]']],
    processEscapes: true,
    processEnvironments: true,
    packages: { '[+]': ['ams'] },
    // 添加宏定义，确保\boldsymbol正确工作
    macros: {
      boldsymbol: ['\\mathbf{#1}', 1]
    }
  },
  // svg: {
  //   fontCache: 'global',
  //   scale: 1,
  //   minScale: 0.5,
  //   maxScale: 2,
  //   matchFontHeight: false,
  //   mtextInheritFont: true,
  //   merrorInheritFont: false,
  //   // 禁用自动缩放，避免NaN宽度问题
  //   autoscale: false,
  //   // 强制使用百分比宽度
  //   width: '100%',
  //   // 确保使用安全的尺寸计算
  //   exFactor: 0.5
  // },
  options: {
    skipHtmlTags: ['script', 'noscript', 'style', 'textarea', 'pre', 'code'],
    ignoreHtmlClass: 'tex-ignore',
    processHtmlClass: 'tex-process'
  },
  loader: {
    load: ['[tex]/ams']
  },
  startup: {
    ready: function() { /* eslint-disable no-undef */
      // 保存原始的pageReady方法
      const originalPageReady = MathJax.startup.defaultPageReady

      // 重写pageReady方法
      MathJax.startup.pageReady = function() {
        try {
          // 执行预处理
          window.replaceMathJaxSymbols()

          // 调用原始的pageReady
          originalPageReady()
        } catch (e) {
          console.error('MathJax启动错误:', e)
        }
      }

      // 执行MathJax启动
      MathJax.startup.defaultReady()
    },
    pageReady: function() { /* eslint-disable no-undef */
      try {
        // 渲染前再次预处理
        window.replaceMathJaxSymbols()

        // 覆盖SVG渲染器的Render方法以处理宽度计算问题
        if (MathJax && MathJax.output && MathJax.output.svg && MathJax.output.svg.renderer) {
          const originalRender = MathJax.output.svg.renderer.prototype.Render
          MathJax.output.svg.renderer.prototype.Render = function() {
            try {
              // 调用原始渲染方法
              const result = originalRender.apply(this, arguments)

              // 检查并修复NaN宽度问题
              if (this.element && this.element.style) {
                if (this.element.style.width && this.element.style.width.includes('NaN')) {
                  this.element.style.width = 'auto'
                }
                if (this.element.style.height && this.element.style.height.includes('NaN')) {
                  this.element.style.height = 'auto'
                }
              }

              return result
            } catch (e) {
              console.warn('SVG渲染错误:', e)
              // 如果渲染失败，应用安全的样式
              if (this.element && this.element.style) {
                this.element.style.width = 'auto'
                this.element.style.height = 'auto'
              }
              return null
            }
          }
        }

        // 执行渲染
        MathJax.typesetPromise()
      } catch (e) {
        console.error('MathJax页面准备错误:', e)
      }
    }
  }
}

// 监听DOMContentLoaded事件，确保页面内容加载完成后进行预处理
document.addEventListener('DOMContentLoaded', function() { /* eslint-disable no-undef */
  // 初始预处理
  setTimeout(() => {
    window.replaceMathJaxSymbols()
    // 如果MathJax已加载，触发渲染
    if (window.MathJax && window.MathJax.typeset) {
      window.MathJax.typesetPromise()
    }
  }, 100)
})

// 添加MutationObserver监听动态内容变化
const observer = new MutationObserver(function(mutations) {
  let needUpdate = false

  mutations.forEach(function(mutation) {
    if (mutation.addedNodes.length > 0) {
      needUpdate = true
    }
  })

  if (needUpdate) {
    setTimeout(() => {
      window.replaceMathJaxSymbols()
      if (window.MathJax && window.MathJax.typeset) {
        window.MathJax.typesetPromise()
      }
    }, 50)
  }
})

// 开始观察文档变化
observer.observe(document.body, {
  childList: true,
  subtree: true
})

